import React from "react";

import { Button, Input, Modal, Form } from "antd";
import { FirebaseAppVariant, MobileNotification, MobileNotificationType } from "../../../utils/interfaces";
import { Control, Controller, FieldErrors, UseFormHandleSubmit } from "react-hook-form";
import TextArea from "antd/es/input/TextArea";
// utils

interface MobileNotificationSendModalProps {
  showSendMobileNotificationModal: boolean,
  toggleSendMobileNotificationModal: (makeVisible: boolean) => void,
  handleSubmit: UseFormHandleSubmit<MobileNotification, MobileNotification>,
  errors: FieldErrors<MobileNotification>,
  onSubmit: (data: MobileNotification, appVariant: FirebaseAppVariant) => void,
  control: Control<MobileNotification, any, MobileNotification>,
  isValid: boolean,
  isSubmitting: boolean,
  notificationTopic: MobileNotificationType
}

const MobileNotificationSendModal: React.FC<MobileNotificationSendModalProps> = ({
  showSendMobileNotificationModal,
  toggleSendMobileNotificationModal,
  handleSubmit,
  errors,
  onSubmit,
  control,
  isValid,
  isSubmitting,
  notificationTopic
}) => {

  return (
    <Modal
      title={'Create Mobile Notification'}
      open={showSendMobileNotificationModal}
      onCancel={() => toggleSendMobileNotificationModal(false)}
      closable={!isSubmitting}
      mask={{ closable: !isSubmitting }}
      footer={[
        <Button onClick={() => toggleSendMobileNotificationModal(false)} disabled={isSubmitting}>Cancel</Button>,
        <Button
          onClick={handleSubmit((data) => onSubmit(data, FirebaseAppVariant.production))}
          type="primary"
          disabled={!isValid || isSubmitting}
          loading={isSubmitting}
          danger
        >Send PRODUCTION</Button>,
        <Button
          onClick={handleSubmit((data) => onSubmit(data, FirebaseAppVariant.developement))}
          type="primary"
          disabled={!isValid || isSubmitting}
          loading={isSubmitting}
        >Send DEVELOPEMENT</Button>
      ]}
    >
      <Form layout="vertical" preserve={false}>
        <Form.Item
          label="Notification Title"
          validateStatus={errors.title ? "error" : ""}
          help={errors.title?.message}
        >
          <Controller
            name="title"
            control={control}
            rules={{required: "Title is required!"}}
            render={({ field }) => (
              <Input {...field} placeholder="Enter title..." />
            )}
          />
        </Form.Item>
        <Form.Item
          label="Notification Body"
          validateStatus={errors.body ? "error" : ""}
          help={errors.body?.message}
        >
          <Controller
            name="body"
            control={control}
            rules={{required: "Body is required!"}}
            render={({ field }) => (
              <TextArea {...field} placeholder="Enter body..." />
            )}
          />
        </Form.Item>
        <Form.Item
          label="Type"
        >
          <Input value={notificationTopic} disabled/>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default MobileNotificationSendModal;
